module.exports = __webpack_public_path__ + "static/media/spinner.ebe8630f.svg";